"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _atom = require("atom");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UISearchableSelectInput = _interopRequireDefault(require("UIComponents/input/UISearchableSelectInput"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _BaseDialog = _interopRequireDefault(require("customer-data-ui-utilities/dialog/BaseDialog"));

var propTypes = (0, _extends2.default)({
  pipelineId: _react.PropTypes.string.isRequired,
  stageId: _react.PropTypes.string.isRequired,
  resolver: _ReferenceResolverType.default.isRequired,
  objectType: _ObjectTypesType.default.isRequired
}, _PromptablePropInterface.default);

var getPipelineStageOptions = function getPipelineStageOptions(pipeline) {
  return pipeline.get('stages').map(function (stage) {
    return stage.merge({
      value: stage.get('stageId'),
      text: stage.get('label')
    });
  });
};

var ChangePipelineDialog =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ChangePipelineDialog, _PureComponent);

  function ChangePipelineDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ChangePipelineDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ChangePipelineDialog).call(this, props));
    _this.partial = (0, _ComponentMethods.makePartial)();
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    var stageId = props.stageId,
        pipelineId = props.pipelineId;
    _this.state = {
      pipelineId: pipelineId,
      pipelines: (0, _immutable.Map)(),
      pipelineOptions: [],
      stageId: stageId
    };
    return _this;
  }

  (0, _createClass2.default)(ChangePipelineDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleInitReferenceAtom();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handlePipelinesReferenceChange);
      }
    }
  }, {
    key: "handleInitReferenceAtom",
    value: function handleInitReferenceAtom() {
      this.referenceAtom = this.props.resolver.all();
      (0, _atom.watch)(this.referenceAtom, this.handlePipelinesReferenceChange);
      this.handlePipelinesReferenceChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "handlePipelinesReferenceChange",
    value: function handlePipelinesReferenceChange(reference) {
      if (!reference) {
        return;
      }

      var pipelineOptions = reference.map(function (_ref) {
        var pipeline = _ref.referencedObject;
        return {
          value: pipeline.get('pipelineId'),
          text: pipeline.get('label')
        };
      }).toJS();
      var pipelines = reference.reduce(function (acc, _ref2) {
        var pipeline = _ref2.referencedObject;

        if (!pipeline.get('stageOptions')) {
          pipeline = pipeline.merge({
            stageOptions: getPipelineStageOptions(pipeline)
          });
        }

        return acc.set(pipeline.get('pipelineId'), pipeline);
      }, (0, _immutable.Map)());
      this.setState({
        pipelines: pipelines,
        pipelineOptions: pipelineOptions
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(property, evt) {
      var inputChanges = {};
      var newValue = evt.target.value;
      inputChanges[property] = newValue;

      if (property === 'pipelineId') {
        inputChanges.stageId = this.state.pipelines.getIn([newValue, 'stages']).first().get('stageId');
      }

      return this.setState(inputChanges);
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var updates = (0, _immutable.fromJS)({
        pipelineId: this.state.pipelineId,
        stageId: this.state.stageId
      });
      return this.props.onConfirm(updates);
    }
  }, {
    key: "renderPipelineSelect",
    value: function renderPipelineSelect() {
      var _this$state = this.state,
          pipelineId = _this$state.pipelineId,
          pipelineOptions = _this$state.pipelineOptions;
      return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 12
        }
      }, _react.default.createElement(_UISearchableSelectInput.default, {
        onChange: this.partial(this.handleInputChange, 'pipelineId'),
        options: pipelineOptions,
        value: pipelineId
      })));
    }
  }, {
    key: "renderStageSelect",
    value: function renderStageSelect() {
      var _this$state2 = this.state,
          pipelineId = _this$state2.pipelineId,
          stageId = _this$state2.stageId,
          pipelines = _this$state2.pipelines;
      var stages = pipelines.getIn([pipelineId, 'stageOptions']);
      stages = stages ? stages.toJS() : [];
      return _react.default.createElement(_UIGrid.default, {
        className: "m-top-5"
      }, _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 12
        }
      }, _react.default.createElement(_UISearchableSelectInput.default, {
        onChange: this.partial(this.handleInputChange, 'stageId'),
        options: stages,
        value: stageId
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          onReject = _this$props.onReject;
      return _react.default.createElement(_BaseDialog.default, {
        title: _I18n.default.text("customerDataObjectsUiComponents.ChangePipelineDialog.title." + objectType),
        confirmLabel: _I18n.default.text('customerDataObjectsUiComponents.ChangePipelineDialog.save'),
        onConfirm: this.handleSave,
        onReject: onReject,
        width: 500
      }, this.renderPipelineSelect(), this.renderStageSelect());
    }
  }]);
  return ChangePipelineDialog;
}(_PureComponent2.default);

ChangePipelineDialog.propTypes = propTypes;

var _default = (0, _Promptable.default)(ChangePipelineDialog);

exports.default = _default;
module.exports = exports.default;